import { useState, useEffect } from 'react';
import api from '../services/api';

const css = `
.me-wrap{max-width:820px;margin:0 auto;padding:4px;}
.me-card{background:var(--surface);border:1px solid var(--border);border-radius:10px;padding:18px;margin-bottom:16px;}
.me-title{font-size:15px;font-weight:700;margin-bottom:4px;color:var(--navy);}
.me-sub{font-size:12px;color:var(--text2);margin-bottom:16px;}
.me-field{margin-bottom:12px;}
.me-label{font-size:11px;font-weight:600;color:var(--text2);display:block;margin-bottom:4px;}
.me-inp{width:100%;padding:8px 10px;font-size:13px;border:1px solid var(--border);border-radius:6px;}
.me-sug{border:1px solid var(--border);border-radius:6px;margin-top:2px;max-height:180px;overflow-y:auto;background:#fff;position:relative;z-index:5;}
.me-sug-item{padding:8px 10px;font-size:12.5px;cursor:pointer;border-bottom:1px solid var(--bg);}
.me-sug-item:hover{background:var(--blue-lt);}
.me-pac-sel{display:flex;align-items:center;justify-content:space-between;background:var(--blue-lt);border-radius:6px;padding:8px 10px;font-size:13px;font-weight:600;}
.me-msg-ok{background:#e6f4ea;color:#1e7e34;padding:8px 10px;border-radius:6px;font-size:12.5px;margin-top:10px;}
.me-msg-err{background:#fce8e6;color:#c62828;padding:8px 10px;border-radius:6px;font-size:12.5px;margin-top:10px;}
.me-recientes{font-size:12px;}
.me-recientes table{width:100%;border-collapse:collapse;}
.me-recientes th{text-align:left;padding:6px 8px;font-size:10.5px;color:var(--text2);border-bottom:1px solid var(--border);}
.me-recientes td{padding:6px 8px;border-bottom:1px solid var(--bg);}
`;

export default function MigracionEvoluciones() {
  const [busq, setBusq] = useState('');
  const [sugs, setSugs] = useState([]);
  const [paciente, setPaciente] = useState(null);
  const [medicos, setMedicos] = useState([]);
  const [medicoAtribuido, setMedicoAtribuido] = useState('');
  const [fechaOriginal, setFechaOriginal] = useState('');
  const [evolucion, setEvolucion] = useState('');
  const [saving, setSaving] = useState(false);
  const [ok, setOk] = useState('');
  const [err, setErr] = useState('');
  const [recientes, setRecientes] = useState([]);

  useEffect(() => {
    api.get('/historia/migracion-evolucion/medicos').then(r => setMedicos(r.data || [])).catch(() => {});
    cargarRecientes();
  }, []);

  const cargarRecientes = () => {
    api.get('/historia/migracion-evolucion/recientes').then(r => setRecientes(r.data || [])).catch(() => {});
  };

  useEffect(() => {
    if (busq.length < 2 || paciente) { setSugs([]); return; }
    const t = setTimeout(async () => {
      try { const { data } = await api.get(`/pacientes?q=${encodeURIComponent(busq)}&limit=6`); setSugs(data); } catch {}
    }, 300);
    return () => clearTimeout(t);
  }, [busq, paciente]);

  const nombrePaciente = p => `${p.APELLIDO_PATERNO||''} ${p.APELLIDO_MATERNO||''} ${p.PRIMER_NOMBRE||''}`.replace(/\s+/g,' ').trim();

  const limpiarForm = (mantenerPaciente = false) => {
    setEvolucion('');
    setFechaOriginal('');
    if (!mantenerPaciente) { setPaciente(null); setBusq(''); }
  };

  const guardar = async () => {
    setErr(''); setOk('');
    if (!paciente) { setErr('Selecciona un paciente'); return; }
    if (!medicoAtribuido) { setErr('Selecciona a qué médico se atribuye esta evolución'); return; }
    if (!evolucion.trim()) { setErr('Pega o escribe el texto de la evolución'); return; }
    setSaving(true);
    try {
      await api.post('/historia/migracion-evolucion', {
        COD_PACIENTE: paciente.COD,
        EVOLUCION: evolucion.trim(),
        MEDICO_ATRIBUIDO: medicoAtribuido,
        FECHA_ORIGINAL: fechaOriginal || undefined,
      });
      setOk(`✓ Evolución de ${nombrePaciente(paciente)} guardada correctamente`);
      limpiarForm(true);
      cargarRecientes();
    } catch (e) {
      setErr(e.response?.data?.error || 'No se pudo guardar la evolución');
    }
    setSaving(false);
  };

  return (
    <div className="me-wrap">
      <style>{css}</style>
      <div className="me-card">
        <div className="me-title">Migración de evoluciones del sistema anterior</div>
        <div className="me-sub">
          Uso temporal mientras se traslada la información del sistema antiguo. Cada evolución que
          transcribas queda registrada a nombre del médico que selecciones — tu usuario solo queda
          anotado como quien transcribió, para el rastro de auditoría.
        </div>

        <div className="me-field">
          <label className="me-label">Paciente *</label>
          {paciente ? (
            <div className="me-pac-sel">
              <span>{nombrePaciente(paciente)} — {paciente.IDENTIFICACION}</span>
              <span style={{cursor:'pointer'}} onClick={() => { setPaciente(null); setBusq(''); }}>&#x2715;</span>
            </div>
          ) : (
            <>
              <input className="me-inp" placeholder="Buscar paciente por nombre o cédula..."
                value={busq} onChange={e => setBusq(e.target.value)} />
              {sugs.length > 0 && (
                <div className="me-sug">
                  {sugs.map(p => (
                    <div key={p.COD} className="me-sug-item" onClick={() => { setPaciente(p); setSugs([]); }}>
                      {nombrePaciente(p)} — {p.IDENTIFICACION}
                    </div>
                  ))}
                </div>
              )}
            </>
          )}
        </div>

        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
          <div className="me-field">
            <label className="me-label">Médico al que se atribuye *</label>
            <select className="me-inp" value={medicoAtribuido} onChange={e => setMedicoAtribuido(e.target.value)}>
              <option value="">Selecciona...</option>
              {medicos.map(m => <option key={m.USUARIO} value={m.USUARIO}>{m.NOMBRES}</option>)}
            </select>
          </div>
          <div className="me-field">
            <label className="me-label">Fecha original de la evolución (opcional)</label>
            <input type="date" className="me-inp" value={fechaOriginal} onChange={e => setFechaOriginal(e.target.value)} />
          </div>
        </div>

        <div className="me-field">
          <label className="me-label">Texto de la evolución (tal como está en el sistema anterior) *</label>
          <textarea className="me-inp" rows={8} value={evolucion} onChange={e => setEvolucion(e.target.value)}
            placeholder="Pega o escribe aquí el texto completo de la última evolución..." />
        </div>

        <button className="btn btn-primary" disabled={saving} onClick={guardar}>
          {saving ? 'Guardando...' : 'Guardar evolución migrada'}
        </button>

        {ok && <div className="me-msg-ok">{ok}</div>}
        {err && <div className="me-msg-err">{err}</div>}
      </div>

      <div className="me-card">
        <div className="me-title" style={{fontSize:13}}>Últimas transcritas</div>
        <div className="me-recientes">
          <table>
            <thead>
              <tr><th>Paciente</th><th>Médico</th><th>Fecha</th><th>Transcrito</th></tr>
            </thead>
            <tbody>
              {recientes.length === 0 && (
                <tr><td colSpan={4} style={{textAlign:'center',padding:14,color:'#8895a5'}}>Sin registros todavía</td></tr>
              )}
              {recientes.map(r => (
                <tr key={r.COD}>
                  <td>{r.PACIENTE}</td>
                  <td>{r.MEDICO_NOM}</td>
                  <td>{r.FECHA ? String(r.FECHA).slice(0,10) : ''}</td>
                  <td>{r.FECHA_CREACION ? String(r.FECHA_CREACION).slice(0,16).replace('T',' ') : ''}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
